import { render, staticRenderFns } from "./CampaignSpecifiedChart.vue?vue&type=template&id=c08839be&scoped=true&"
import script from "./CampaignSpecifiedChart.vue?vue&type=script&lang=js&"
export * from "./CampaignSpecifiedChart.vue?vue&type=script&lang=js&"
import style0 from "./CampaignSpecifiedChart.vue?vue&type=style&index=0&id=c08839be&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c08839be",
  null
  
)

export default component.exports